var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.445,
    height: 7.58,
    viewBox: "0 0 12.445 7.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrowUp",
    transform: "translate(11.574 0.871) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    d: "M5.351.486.486,5.351",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5_Copy",
    "data-name": "Line 5 Copy",
    d: "M5.351-.486.486-5.351",
    transform: "translate(0 10.703)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.92
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.caf1ecd4a47a13230fc5ea5978d8cf8b.svg";
export { ForwardRef as ReactComponent };